import { render, staticRenderFns } from "./copy_auth_code.vue?vue&type=template&id=649c1d9e&scoped=true&"
import script from "./copy_auth_code.vue?vue&type=script&lang=js&"
export * from "./copy_auth_code.vue?vue&type=script&lang=js&"
import style0 from "./copy_auth_code.vue?vue&type=style&index=0&id=649c1d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649c1d9e",
  null
  
)

export default component.exports